import { render } from "./category-list-modal.vue?vue&type=template&id=6e12b198"
import script from "./category-list-modal.vue?vue&type=script&lang=js"
export * from "./category-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__